var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconUsdt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5397_207343)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.982 9.99581C19.982 15.4913 15.5273 19.9461 10.0318 19.9461C4.53647 19.9461 0.081543 15.4913 0.081543 9.99581C0.081543 4.50039 4.53647 0.0455627 10.0318 0.0455627C15.5273 0.0455627 19.982 4.50039 19.982 9.99581Z",
    fill: "#1BA27A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7022 5.06183H5.28027V7.33646H8.8539V10.6797H11.1285V7.33646H14.7022V5.06183Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0115 11.0368C7.05531 11.0368 4.65859 10.5689 4.65859 9.99169C4.65859 9.41458 7.05521 8.94662 10.0115 8.94662C12.9677 8.94662 15.3644 9.41458 15.3644 9.99169C15.3644 10.5689 12.9677 11.0368 10.0115 11.0368ZM16.022 10.1659C16.022 9.42164 13.331 8.81836 10.0115 8.81836C6.69212 8.81836 4.00098 9.42164 4.00098 10.1659C4.00098 10.8213 6.08764 11.3674 8.85272 11.4884V16.2878H11.1271V11.4903C13.9135 11.3731 16.022 10.8247 16.022 10.1659Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5397_207343"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUsdt);
export default __webpack_public_path__ + "static/media/ICON_USDT.8847f2f0163452c15712627e76f8b2ec.svg";
export { ForwardRef as ReactComponent };